export default {
    "data": {
        pc:{
            tabList:[
                {
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614915189787.png',
                    name:'Java',
                    des:'不过时、功能强大',
                    url:'https://edu.lagou.com/growth/sem/java_basic_sem_search.html#/index'
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924425845.png',
                    name:'大数据',
                    des:'潮流技术、未来新时代',
                    url:"https://edu.lagou.com/growth/sem/data_basic_sem_search.html#/index"
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924451444.png',
                    name:'大前端',
                    des:'界面交互功能更强大',
                    url:'https://edu.lagou.com/growth/sem/web_basic_sem_search.html#/index'
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924472683.png',
                    name:'Python',
                    des:'人工智能主流语言',
                    url:''
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924490720.png',
                    name:'软件测试',
                    des:'就业门槛低，人才需求大',
                    url:''
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924508337.png',
                    name:'UX设计',
                    des:'身价不断攀升',
                    url:''
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924526030.png',
                    name:'数据分析',
                    des:'数学与计算机科学相结合的产物',
                    url:''
                },{
                    img:'https://s21.lgstatic.com/growth/activity/20210305/1614924543371.png',
                    name:'产品经理',
                    des:'将用户体验做到极致',
                    url:''
                }
            ],
            sectionViewList:[
                "https://s21.lgstatic.com/growth/activity/20210305/1614926270320.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614926304315.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614926424410.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614926437540.png"
            ],
            tabBgList:[
                {
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928173502.png",
                    name:"Java",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928204399.png",
                    name:"大数据",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928217017.png",
                    name:"大前端",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928228071.png",
                    name:"数据分析",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928247362.png",
                    name:"UX设计",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928260116.png",
                    name:"软件测试",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928272463.png",
                    name:"全链路设计",
                    activeUrl:""
                },{
                    url: "https://s21.lgstatic.com/growth/activity/20210305/1614928284188.png",
                    name:"产品经理",
                    activeUrl:""
                }
            ],
            tabImgList:[
                "https://s21.lgstatic.com/growth/activity/20210305/1614932857001.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932295470.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932310796.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932408836.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932483530.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932502463.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932522243.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614932532149.png"
            ],
            swiperList:[
                {
                    url:"https://s21.lgstatic.com/growth/activity/20210305/1614935760182.png"
                },{
                    url:"https://s21.lgstatic.com/growth/activity/20210305/1614935805328.png"
                }
            ],
            sectionList:[
                "https://s21.lgstatic.com/growth/activity/20210305/1614938612078.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614938770788.png",
                "https://s21.lgstatic.com/growth/activity/20210305/1614939099938.png"
            ],
        },
        h5:{
            mainList:[
                {
                    title:"Java",
                    detail:[
                        {
                            title:"Java SE",
                            txt:[
                                "Java基础语法、Java数组、面向对象编程、异常处理、集合与泛型、Java多线程、Java SE项目等",
                            ]
                        },{
                            title:"数据库技术",
                            txt:[
                                "MySQL、SQL语言、JDBC操作等",
                            ]
                        },{
                            title:"前端技术",
                            txt:[
                                "HTML、CSS、JavaScript、ES6等",
                            ]
                        },{
                            title:"JavaWEB核心",
                            txt:[
                                "Tomcat、Servlet、Jsp、MVC模式&三层架构等",
                            ]
                        },{
                            title:"单体架构项目",
                            txt:[
                                "Ajax&Json、Vue基础、Linux、拉勾教育后台管理系统等",
                            ]
                        }
                    ],
                    other:"等12阶段知识体系"
                },{
                    title:"大数据",
                    detail:[
                        {
                            title:"Java SE核心知识",
                            txt:[
                                "Java编程概述及基础语法",
                                "Java集合与泛型",
                                "Java多线程技术",
                                "Java SE网路编程"
                            ]
                        },{
                            title:"Java Web数据可视化",
                            txt:[
                                "Java Web 后端技术",
                                "前端可视化技术",
                                "关系型数据库MySQL高级应用",
                                "Linux 服务器应用实战",
                                "拉勾招聘行业报表数据",
                                "可视化项目实战"
                            ]
                        },{
                            title:"Hadoop核心及生态圈技术栈",
                            txt:[
                                "Hadoop核心之分布式文件系统HDFS",
                                "Hadoop核心之分布式计算框架MapReduce",
                                "Hadoop核心之分布式资源调度框架Yarn",
                                "Hadoop生态圈技术栈（上、下）"
                            ]
                        },{
                            title:"分布式缓存Redis及Kafka消息中间件",
                            txt:[
                                "高性能分布式缓存Redis",
                                "高吞吐消息中间件Kafka"
                            ]
                        },{
                            title:"PB级电商离线数仓项目实战",
                            txt:[
                                "数仓分层建设及理论梳理",
                                "数仓建设痛点剖析",
                                "离线数仓全流程性能优化方案",
                                "电商行业离线数仓业务真实级"
                            ]
                        }
                    ],
                    other:"等14阶段知识体系"
                },{
                    title:"大前端",
                    detail:[
                        {
                            title:"JavaScript 深度剖析",
                            txt:[
                                "ECMAScript 新特性",
                                "JavaScript 异步编程",
                                "TypeScript 高级编程",
                                "函数式编程范式",
                                "JavaScript 性能优化"
                            ]
                        },{
                            title:"前端工程化实战",
                            txt:[
                                "脚手架工具",
                                "自动化构建",
                                "自动化测试",
                                "自动化部署（CI / CD）",
                                "模块化开发与 Webpack",
                                "规范化标准"
                            ]
                        },{
                            title:"核心框架原理与进阶",
                            txt:[
                                "Vue.js 原理深度剖析",
                                "Vue.js 高级与进阶",
                                "React 设计原理解密",
                                "React 进阶与实战",
                                "Angular 企业实战开发"
                            ]
                        },{
                            title:"Node.js 全栈开发",
                            txt:[
                                "Node.js 高级编程",
                                "NoSQL 数据库",
                                "GraphQL API 开发",
                                "企业级框架"
                            ]
                        },{
                            title:"泛客户端开发",
                            txt:[
                                "小程序与快应用",
                                "Hybrid App 开发",
                                "React Native",
                                "Flutter 原生 App 开发",
                                "Electron 桌面应用开发"
                            ]
                        }
                    ],
                    other:"等8大阶段知识体系"
                },{
                    title:"数据分析",
                    detail:[
                        {
                            title:"数据分析思维与业务流程",
                            txt:[
                                "数据分析入门",
                                "业务模型拆解",
                                "问题解决框架与应用",
                                "Excel数据分析基础应用"
                            ]
                        },{
                            title:"MySQL数据分析实战",
                            txt:[
                                "通过SQL查询业务指标",
                                "SQL高效查询优化",
                                "构建结构化业务数据库/表",
                                "业务指标统计分析",
                                "案例：电商数据多表查询",
                                "案例：电商用户价值划分"
                            ]
                        },{
                            title:"互联网公司必备-BI可视化工具",
                            txt:[
                                "Tableau 业务指标可视化",
                                "神策数据平台—业务数据获取及可视化",
                                "Quick BI 云服务数据获取及可视化",
                                "搭建推广渠道评估指标体系"
                            ]
                        },{
                            title:"大数据查询利器Hive",
                            txt:[
                                "HQL海量业务数据需求查询",
                                "HQL业务数据指标统计分析",
                                "HQL海量数据查询优化",
                                "案例：在线教育用户画像数据获取",
                                "案例：在线教育用户生命周期模型"
                            ]
                        },{
                            title:"数据分析必学编程语言-Python",
                            txt:[
                                "Python数据分析基础",
                                "Python爬取非标准化数据",
                                "数值高效计算（Numpy科学计算库）",
                                "数据获取与处理分析数据展现绘图模块",
                                "案例：电商用户行为分析）"
                            ]
                        }
                    ],
                    other:"等10大阶段知识体系"
                },{
                    title:"UX设计",
                    detail:[
                        {
                            title:"全方位认识交互设计师做好自我定位",
                            txt:[
                                "用户体验与交互设计案例分析",
                                "如何选择一款适合你的设计软件"
                            ]
                        },{
                            title:"培养需求挖掘能力，掌握真正的用户调研方法",
                            txt:[
                                "挖掘商业需求和用户需求",
                                "定性调研和定量调研"
                            ]
                        },{
                            title:"培养分析能力，掌握竞品分析底层方法",
                            txt:[
                                "竞品分析第一",
                                "竞品分析第二"
                            ]
                        },{
                            title:"用户建模、用户行为旅程、故事板的制作方法",
                            txt:[
                                "用户建模",
                                "行为旅程设计和故事版"
                            ]
                        },{
                            title:"培养机会点洞察能力，掌握创意的产生与评估方法",
                            txt:[
                                "创意的产生和评估一",
                                "创意的产生和评估二",
                                "将创意转化成草图并验证"
                            ]
                        }
                    ],
                    other:"等10大阶段知识体系"
                },{
                    title:"软件测试",
                    detail:[
                        {
                            title:"测试流程与理",
                            txt:[
                                "软件开发流程与项目管理",
                                "测试流程体系",
                                "测试技术体系",
                                "常用测试平台",
                                "黑盒测试方法论",
                                "白盒测试方法论",
                                "测试经典书籍拆分讲解",
                                "测试工程师测试工作实战演练"
                            ]
                        },{
                            title:"Linux与Bash脚本课程",
                            txt:[
                                "Linux 系统与 Shell 环境准备",
                                "Linux 常用命令 ",
                                "Linux 三剑客与管道使用",
                                "Bash 编程语法",
                                "Bash 脚本编写",
                                "三剑客实战 Nginx 日志分析",
                                "三剑客实战 Linux 性能统计分析",
                                "三剑客抽奖程序脚本编写"
                            ]
                        },{
                            title:"python实战课程",
                            txt:[
                                "Python 环境管理与 pip 依赖管理",
                                "Python 基本数据类型与操作",
                                "Python 控制流语法",
                                "Python 函数",
                                "Python 常用数据结构",
                                "Python 模块",
                                "……"
                            ]
                        },{
                            title:"Pytest测试框架",
                            txt:[
                                "Pip 依赖管理与虚拟环境",
                                "Unittest 测试框架",
                                "Pytest 测试框架",
                                "参数化用例",
                                "数据驱动（YAML、JSON、Excel、CSV）",
                                "测试报告定制",
                                "Python Pytest测试实战"
                            ]
                        },{
                            title:"Web自动化测试",
                            txt:[
                                "Selenium 的安装",
                                "Selenium IDE 用例录制",
                                "Selenium 测试用例编写",
                                "隐式等待与显式等待",
                                "Web 控件定位",
                                "Web 控件交互",
                                "网页 frame 与多窗口处理",
                                "……"
                            ]
                        }
                    ],
                    other:"等18大阶段知识体系"
                },{
                    title:"全链路设计师",
                    detail:[
                        {
                            title:"了解交互设计师做好自我定位",
                            txt:[
                                "基本概念和案例介绍",
                                "基本概念 - 如何选择一款适合你的设计软件"
                            ]
                        },{
                            title:"培养商业思维  强化分析和调研能力",
                            txt:[
                                "需求调研能力 - 定性调研和定量调研",
                                "用户调研能力 - 挖掘商业需求和用户需求",
                                "本阶段小项目"
                            ]
                        },{
                            title:"培养分析能力  掌握竞品分析底层方法",
                            txt:[
                                "竞品分析能力 - 竞品分析一",
                                "竞品分析能力 - 竞品分析二",
                                "本阶段小项目"
                            ]
                        },{
                            title:"培养用户洞察能力  掌握分析用户的方法",
                            txt:[
                                "用户分析能力 - 用户建模",
                                "用户分析能力 - 行为旅程设计和故事板",
                                "本阶段小项目"
                            ]
                        },{
                            title:"培养机会点洞察能力  掌握创意的产生和评估方法",
                            txt:[
                                "逻辑能力 - 创意的产生和评估一",
                                "逻辑能力 - 创意的产生和评估二",
                                "创意方法 - 将创意转化成草图并验证",
                                "本阶段小项目"

                            ]
                        }
                    ],
                    other:"等11大阶段知识体系"
                },{
                    title:"产品经理",
                    detail:[
                        {
                            title:"全方位认识产品经理，做好自我定位",
                            txt:[
                                "重新认识产品和产品经理",
                                "干货分享：怎样组织一场头脑风暴",
                                "本阶段作业"
                            ]
                        },{
                            title:"产品从无到有概况，掌握产品全流程",
                            txt:[
                                "产品设计",
                                "产品概览-产品设计案例",
                                "本阶段小项目"
                            ]
                        },{
                            title:"掌握用户需求分析，让产品有源可溯",
                            txt:[
                                "需求分析-需求概念和分类",
                                "需求分析-需求挖掘方法",
                                "本阶段小项目"
                            ]
                        },{
                            title:"敏捷方法与用户故事、线框图",
                            txt:[
                                "需求输出-用户故事方法",
                                "需求输出-线框图",
                                "本阶段小项目"
                            ]
                        },{
                            title:"TO B产品设计的系统设计思路",
                            txt:[
                                "需求输出-功能需求说明书概述",
                                "需求输出-流程图概述",
                                "B端产品设计",
                                "本阶段小项目"
                            ]
                        }
                    ],
                    other:"等10大阶段知识体系"
                }
            ],
            swiperLsit:[
                "https://s21.lgstatic.com/growth/activity/20210514/1620972697835.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616382078080.png",
                // "https://s21.lgstatic.com/growth/activity/20210322/1616382087420.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616382096007.png",
            ],
            swiperLsit1:[
                "https://s21.lgstatic.com/growth/activity/20210322/1616400789823.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616400799169.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616400807706.png"
            ],
            sectionImgList:[
                "https://s21.lgstatic.com/growth/activity/20210322/1616384131769.png",

                "https://s21.lgstatic.com/growth/activity/20210322/1616394508677.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616394594163.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616394608250.png",

                "https://s21.lgstatic.com/growth/activity/20210322/1616394644732.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616400459481.png",

                "https://s21.lgstatic.com/growth/activity/20210322/1616401522885.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616401540843.png",

                "https://s21.lgstatic.com/growth/activity/20210322/1616401725488.png"
            ],
            buttonImgList:[
                "https://s21.lgstatic.com/growth/activity/20210322/1616393918136.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616400359207.png",
                "https://s21.lgstatic.com/growth/activity/20210322/1616402393721.png"
            ],
            h5footerImg:"https://s21.lgstatic.com/growth/activity/20210322/1616401827356.png"
        }
    }
}